import * as React from 'react';
import { Tag } from '@cian/components';

import { ECoworkingAccess } from '../../../../json_query';
import { ICoworkinAccessTag } from '../../../state/tags/definitions/coworking_access';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface ICoworkingAccessTagItemProps {
  tag: ICoworkinAccessTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const CoworkingAccessTag: React.FC<ICoworkingAccessTagItemProps> = ({ tag, onDeleteClick, withNewTag }) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);
  let title = 'Доступ ';

  if (tag.value === ECoworkingAccess.AllDay) {
    title += 'круглосуточно';
  }

  if (tag.value === ECoworkingAccess.AllWeek) {
    title += 'в выходные дни';
  }

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {title}
    </TagComponent>
  );
};
